import { render, staticRenderFns } from "./BranchMsgDetail.vue?vue&type=template&id=462f551e&scoped=true&"
import script from "./BranchMsgDetail.vue?vue&type=script&lang=js&"
export * from "./BranchMsgDetail.vue?vue&type=script&lang=js&"
import style0 from "./BranchMsgDetail.vue?vue&type=style&index=0&id=462f551e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462f551e",
  null
  
)

export default component.exports